import FullCalendar from "@fullcalendar/react";
import daygridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import frLocale from "@fullcalendar/core/locales/fr";
import {useDailyIntervention} from "../../../hooks/useInterventions";
import Loader from "../../components/shared/Loader";
import "./calendar.css";
import {useNavigate} from "react-router-dom";
import {useState} from "react";
import ReportModal from "../../components/Intervention/ReportModal";
import {getInterventionStatusColor} from "../../../utils/status";
import QueryErrorState from "../../components/shared/QueryErrorState";
import {getInterventionIdentifier} from "../../../utils/interventionUrl";
import {useTranslation} from "react-i18next";

const CalendarIntervention = ({filter, role}) => {
  const {i18n} = useTranslation();
  const {interventions, isError, error, isLoading, refetch} = useDailyIntervention({
    ...filter,
  });

  const [selectedIntervention, setSelectedIntervention] = useState({});
  const [reportModal, setReportModal] = useState(false);

  const navigate = useNavigate();
  if (isLoading) {
    return <Loader />;
  }
  if (isError) {
    return <QueryErrorState error={error} onRetry={refetch} />;
  }
  return (
    <section className="w-full bg-white !rounded-xl p-4">
      <ReportModal
        openModal={reportModal}
        toggleModal={setReportModal}
        intervention={selectedIntervention}
        initialValues={{
          date: !!selectedIntervention?.startDate
            ? new Date(selectedIntervention?.startDate)
                .toISOString()
                .split("T")[0]
            : "",
          time: !!selectedIntervention?.startDate
            ? new Date(selectedIntervention?.startDate)
                .toTimeString()
                .split(":")
                .slice(0, 2)
                .join(":")
            : "",
        }}
        role={role}
      />
      <FullCalendar
        selectable
        // select={handleSelect}
        locale={i18n.resolvedLanguage?.startsWith("en") ? "en" : frLocale}
        plugins={[daygridPlugin, interactionPlugin, timeGridPlugin, listPlugin]}
        views={["dayGridDay", "timeGridMonth", "dayGridWeek"]}
        headerToolbar={{
          right: "timeGridDay,timeGridWeek,dayGridMonth",
          center: "title",
          left: "prev,next",
        }}
        initialDate={new Date()} // using new Date(); and set your scheduled on event array
        navLinks={true} // can click day/week names to navigate views
        businessHours={true} // display business hours
        editable={true}
        events={interventions?.map((el) => ({
          id: getInterventionIdentifier(el),
          internalId: el?.id,
          start: el?.startDate,
          end: el?.endDate,
          title: el?.title,
          color: getInterventionStatusColor({
            status: el.status,
          }).color,
        }))}
        eventChange={(clickInfo) => {
          setSelectedIntervention({
            id: clickInfo.event.extendedProps.internalId,
            title: clickInfo.event._def.title,
            startDate: clickInfo.event.start,
          });
          setReportModal(true);
        }}
        eventClick={(event) => {
          navigate("/intervention/" + event.event._def.publicId);
        }}
        eventContent={RenderEventContent}
        // eventChange={eventChange}
      />
    </section>
  );
};
export default CalendarIntervention;
function RenderEventContent(eventInfo) {
  if (eventInfo) {
    const {timeText, event} = eventInfo;

    return (
      <div
        style={{
          background: eventInfo.backgroundColor,
        }}
        className="flex items-center gap-1 p-1 rounded  text-white truncate "
        title={`${event.title} (${timeText})`} // Tooltip with event title and time
      >
        {/* Event Time */}
        <span className="font-semibold text-[10px]">{timeText}</span>

        {/* Event Title */}
        <span className="truncate text-[10px]">{event.title}</span>
        <div
          className="w-3 aspect-square rounded-full"
          style={{backgroundColor: event.color}}
        ></div>
      </div>
    );
  }
  return null;
}
